export default "__VITE_ASSET__Gz7D1oeG__"